import { createStore, combineReducers } from "redux";

import emailReducer from "./email/Email.reducer";
import fontReducer from "./Font/Font.reducer";

const rootReducer = combineReducers({
  font: fontReducer,
  email: emailReducer,
});

const store = createStore(rootReducer);

export type RootState = ReturnType<typeof rootReducer>;
export default store;
